import { Store } from "vuex"
import { createStore } from "vuex-extensions"

import modules from "./modules"
import { TOGGLE_CLASSIC } from "./types"
import axios from "./axios"

export default createStore(Store, {
  state: {},
  mutations: {},
  plugins: [],
  actions: {
    [TOGGLE_CLASSIC]: () => {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/v3/users/toggle_beta/")
          .then((resp) => {
            if (process.env.NODE_ENV === "development") {
              console.log(resp)
            }
            resolve(resp)
          })
          .catch((err) => {
            if (process.env.NODE_ENV === "development") {
              console.log(err)
            }
            reject(err)
          })
      })
    }
  },
  modules
})
